module.exports = __webpack_public_path__ + "static/media/repo.3452b916.svg";